import { put, call, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../constants';
import { AxiosService } from '../../services';
import { actionTypes } from '../../types';
import { markUserStatusFailure, markUserStatusSuccess } from '../../actions/userActions/markUserStatusActions';
import store from '../../configStore';

function* markUserStatus({ payload }) {
    console.log('====================================');
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.markActiveInActiveUser,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("MARK_ACTIVE_INACTIVE_USER_SUCCESS status :", response.data.status);
        console.log("MARK_ACTIVE_INACTIVE_USER_SUCCESS data :", response.data.response);
        console.log("MARK_ACTIVE_INACTIVE_USER_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            markUserStatusSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
    } catch (error) {
        console.log('====================================');
        console.log("MARK_ACTIVE_INACTIVE_USER_FAILURE status :", error?.response?.status);
        console.log("MARK_ACTIVE_INACTIVE_USER_FAILURE data:", error?.response?.data);
        console.log("MARK_ACTIVE_INACTIVE_USER_FAILURE error :", error);
        console.log('====================================');
        yield put(markUserStatusFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* markUserStatusSaga() {
    yield takeLatest(actionTypes.MARK_ACTIVE_INACTIVE_USER_REQUEST, markUserStatus);
}

export default markUserStatusSaga;
